import { Tooltip } from "react-tooltip";
import { useGlobalModalOpen } from "./GlobalModal";

/** Keep a touch/focus tooltip from the page behind an opened dialog. */
export const GlobalTooltip = () => {
  const modalOpen = useGlobalModalOpen();
  return (
    <Tooltip
      key={modalOpen ? "modal" : "page"}
      id="global-tip"
      className="tooltip"
      anchorSelect={
        modalOpen
          ? '#modal .modal__window [data-tooltip-id="global-tip"]'
          : '[data-tooltip-id="global-tip"]:not(#modal *)'
      }
      disableTooltip={(anchor) =>
        modalOpen
          ? !anchor?.closest("#modal .modal__window")
          : !!anchor?.closest("#modal")
      }
    />
  );
};
